// Form label + control wrapper for the portal pages.
// Children should already be one of .portal-search / .portal-input / .portal-select / .portal-textarea.

import React from 'react';

export default function Field({ label, children, full = false }) {
  return (
    <label className={`portal-field${full ? ' full' : ''}`}>
      <span className="portal-field-label">{label}</span>
      {children}
    </label>
  );
}
